function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef, useState } from 'react';
import { TextField } from "../TextField";
import { EyeFill } from "../../icons/EyeFill";
import styles from "./PasswordField.module.scss";
export const PasswordField = /*#__PURE__*/forwardRef((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  return /*#__PURE__*/React.createElement(TextField, _extends({
    ref: ref,
    type: showPassword ? 'text' : 'password',
    suffix: /*#__PURE__*/React.createElement("span", {
      className: styles.eye,
      onClick: () => setShowPassword(!showPassword)
    }, /*#__PURE__*/React.createElement(EyeFill, null)),
    label: "Password"
  }, props));
});